module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_8-f732d7306150b57f88381d8efb5d0198.png";